export const localeMap = { es: 'es-ES', en: 'en-US' };

export function formatCurrency(value, lang = 'es', opts = {}) {
  if (value === null || value === undefined || Number.isNaN(value)) return null;
  return new Intl.NumberFormat(localeMap[lang] || 'es-ES', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: opts.decimals ?? 0,
    minimumFractionDigits: opts.decimals ?? 0,
  }).format(value);
}

export function formatCompact(value, lang = 'es') {
  if (value === null || value === undefined) return null;
  return new Intl.NumberFormat(localeMap[lang] || 'es-ES', {
    notation: 'compact',
    maximumFractionDigits: 1,
    style: 'currency',
    currency: 'EUR',
  }).format(value);
}

export function formatNumber(value, lang = 'es') {
  return new Intl.NumberFormat(localeMap[lang] || 'es-ES').format(value);
}

export function formatPercent(value, lang = 'es', decimals = 1) {
  const sign = value > 0 ? '+' : '';
  return `${sign}${new Intl.NumberFormat(localeMap[lang] || 'es-ES', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value)}%`;
}
